<template>
  <login-layout title="아이디찾기">
    <div>
      <v-text-field v-model="memberNm" label="이름" outlined />
      <v-text-field v-model="telNum" label="연락처" outlined />
      <v-btn class="px-12" color="primary" @click="searchId">
        아이디찾기
      </v-btn>
    </div>
  </login-layout>
</template>

<script>
import {axiosInstance} from "@/util/AxiosModule";
import LoginLayout from "@/pages/Login/layout/LoginLayout.vue";

export default {
  name: "FindId",
  components: {LoginLayout},
  data() {
    return {
      memberNm: "",
      telNum: "",
      regExp: /[^a-zA-Z0-9]/g
    }
  },
  methods: {
    async searchId() {
      if (
          this.memberNm === "" ||
          this.telNum === ""
      ) {
        await this.showAlert({message: "입력해주신 정보를 확인해주세요"});
        return false;
      }
      try {
        await axiosInstance.get("public/member/findId", {
          params: {
            memberNm: this.memberNm,
            telNum: this.telNum
          }
        }).then(() => {
          this.showAlert({
            message: "입력하신 연락처로 전송되었습니다.",
            successCallback: () => {
              this.goBack();
            }
          });
        })

      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    goBack() {
      this.$router.go(-1); // 이전 페이지로 이동
    }
  }
}
</script>

<style lang="scss" scoped>
.container-layout {
  max-width: 600px;
  .main-layout {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .previous-page {
      width: 100%;
      padding: 20px 0;
      display: flex;
      justify-content: flex-start;
      span {
        font-weight: bold;
      }
      span:hover {
        color: #1772C7;
        cursor: pointer;
      }
    }
    .logo-layout {
      display: flex;
      justify-content: center;
      align-items: center;
      .logo-image {
        width: min(60vw, 200px);
      }
    }
    .card-layout {
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      box-shadow: none;
      .card-title {
        font-weight: bolder;
        font-size: 1.5em;
        color: darkblue;
        justify-content: center;
        margin-bottom: min(2vw, 50px);
      }
    }
  }
}
</style>